import React from 'react';
import RequiredInput from '../common/form/elements/required-input';
import {ControlLabel, FormControl, Col, FormGroup} from 'react-bootstrap';
import {Control, Errors} from 'react-redux-form';
import {connect} from "react-redux";
import {actions} from "react-redux-form";

class DeliveryAddressPartial extends React.Component {

  componentDidMount() {
    const {dispatch, addressDetails, model} = this.props;

    dispatch(actions.load(model, addressDetails));
  }

  render() {
    const {use} = this.props;
    return (
      <Col lg={6} className="mg-top-30" style={{marginLeft: 0, paddingLeft: 0}}>
        <FormGroup>
          <ControlLabel>
            <Control.checkbox model=".use_delivery_address"/> Use alternate delivery address
          </ControlLabel>
          <Errors
            show={{touched: true}}
            className="errors"
            model=".use_delivery_address"/>
        </FormGroup>
        {use && <div>
          <RequiredInput model='.delivery_address_1' label="Delivery Address 1" placeholder="Delivery Address 1"/>
          <FormGroup>
            <ControlLabel> Delivery Address 2</ControlLabel>
            <Control.text
              model=".delivery_address_2"
              placeholder="Delivery Address 2"
              component={FormControl}
            />
          </FormGroup>
          <FormGroup>
            <ControlLabel>Delivery Address 2</ControlLabel>
            <Control.text
              model=".delivery_address_3"
              placeholder="Delivery Address 3"
              component={FormControl}
            />
          </FormGroup>
          <RequiredInput model='.delivery_county' label="County" placeholder="County"/>
          <RequiredInput model='.delivery_eircode' label="Eircode" placeholder="Eircode"/>
          <RequiredInput model='.delivery_town' label="Town" placeholder="Town"/>
        </div>}
      </Col>
    );
  }
}

const mapStateToProps = state => ({
  use: state.deep.admin_outlet_view.use_delivery_address,
});

export default connect(mapStateToProps)(DeliveryAddressPartial);


// WEBPACK FOOTER //
// ./src/components/delivery-address/delivery-address-partial.jsx